export const erpOptions = [{ value: "Wings" }, { value: "WonderSoft" }];
